import { useHistory, useLocation } from 'react-router-dom';
import '../../../styles/floating-labels.css';
import ErrornDialog from '../../Common/ErrorDialog/ErrorDialog';
import { injectIntl } from 'react-intl';
import { useState, useEffect } from 'react';
import { captchaImageDataSet1, captchaImageDataSet2, getApplicationFlow, showAlert } from '../../../Utils/Utility';
import "./captcha.css"
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { verifyCaptcha } from '@mobile-dev/platform/common/redux/actions/LoginAction';
import { clearLogin, clearError, clearRegister } from '@mobile-dev/platform/common/redux/actions/CommonAction';
import Loader from '../Loader';
import { AppConstatnt } from '../../../Utils/AppConstant';
import { registerAction } from '@mobile-dev/platform/common/redux/actions/RegisterAction';

const CaptchaVerifications = ({ intl }) => {
    const location = useLocation();
    const isSignupFlow = location?.state?.isSignupFlow
    const registerData = location?.state?.registerData
    const captchaData = location?.state?.captchaData
    const phone = location?.state?.phone
    const question = captchaData?.Question
    const [captchaImageData, setcaptchaImageData] = useState(captchaImageDataSet1)
    const [selectedCaptcha, setselectedCaptcha] = useState([])
    const [errorStatus, seterrorStatus] = useState()
    const [message, setmessage] = useState()
    const history = useHistory()
    const { formatMessage } = intl;
    const dispatch = useDispatch()
    const captchaResponse = useSelector(state => state.login.captchaResponse)
    const loginData = useSelector(state => state.login);
    const loginError = useSelector(state => state.login.error);
    const [user, setuser] = useState()
    const registrationData = useSelector(state => state.register);
    const registrationErrorStatus = useSelector(state => state.register.error);

    const getSelection = {
        bus1: "bus_selected",
        truck1: "truck_selected",
        car1: "car_selected",
        bike1: "bike_selected",
    }

    useEffect(() => {
        if (selectedCaptcha && selectedCaptcha.length === 2) {
            validateCaptchaSelection()
        }
    }, [selectedCaptcha])

    useEffect(() => {
        if (registrationErrorStatus) {
            showAlert(toast.TYPE.ERROR, `${formatMessage({ id: "app.error_content" })}`);
            history.goBack();
            dispatch(clearError())
        }
    }, [registrationErrorStatus])

    useEffect(() => {
        if (loginError) {
            showAlert(toast.TYPE.ERROR, `${formatMessage({ id: "app.error_content" })}`);
            history.goBack();
            dispatch(clearError())
        }
    }, [loginError])

    useEffect(() => {
        if (loginData.session) {
            setuser(loginData.session)
            dispatch(clearLogin())
        } else if (loginData.authPayload) {
            switch (loginData.authPayload.nextAction) {
                case AppConstatnt.auth.SIGNUP:
                    history.push({ pathname: '/signup', type: AppConstatnt.auth.SIGNUP, state: { mobileNumber: phone.replace('+', '') } });
                    return null;
                default:
                    history.goBack();
                    break;
            }
        }
    }, [loginData])

    useEffect(() => {
        if (captchaResponse) {
            handleNavigation()
            // dispatch(clearCaptchaVerify())
        }
    }, [captchaResponse])

    const handleNavigation = () => {
        if (getApplicationFlow() === AppConstatnt.flow.CARRIER) {
            return history.push('/driverMobile')
        }
        history.goBack();
    }

    const validateCaptchaSelection = () => {
        const isValidCaptchaSelection = selectedCaptcha.every(v => v.id === selectedCaptcha[0].id)
        if (isValidCaptchaSelection) {
            const selectedCaptchaObject = selectedCaptcha[0]
            const data = {
                answer: getSelection[`${selectedCaptchaObject.id}`],
                ...captchaData
            }
            initiateCaptchaVerification(data)
            return
        }
        showAlertAndPopBack()
    }

    const initiateCaptchaVerification = (data) => {
        if (isSignupFlow) {
            const driverData = { ...registerData, captcha: JSON.stringify(data)}
            dispatch(registerAction(driverData, getApplicationFlow()));
            return
        }
        dispatch(verifyCaptcha(user, data?.answer))
    }

    const handleImageClick = (e, el) => {
        e.preventDefault();
        setcaptchaImageData(captchaImageDataSet2)
        setselectedCaptcha([...selectedCaptcha, el])
    }

    const getImagesComponent = () => {
        return captchaImageData && captchaImageData.map((el) => {
            return <div className="captchacolumn">
                <button className="captchaButton" onClick={(e) => {
                    handleImageClick(e, el)
                }}>
                    <img className="captchaimg" src={el.src} />
                </button>
            </div>
        })
    }

    const timerText = (props) => {
        return <h4 className="text-dark-50 text-center mt-0 font-weight-bold">{props.remainingTime}</h4>
    }

    const onTimerComplete = () => {
        showAlertAndPopBack()
    }

    const showAlertAndPopBack = () => {
        showAlert(toast.TYPE.ERROR, `${formatMessage({ id: "app.captcha_failed" })}`);
        history.goBack()
    }

    if (loginData?.loading || registrationData?.loading) return <Loader />

    if (registrationData.user) {
        dispatch(clearError());
        showAlert(toast.TYPE.SUCCESS, formatMessage({ id: "app.otp_register_success" }));
        handleNavigation()
        dispatch(clearRegister());
        return null;
    }

    if (registrationData?.signupAuthPayload) {
        dispatch(clearError());
        showAlert(toast.TYPE.WARNING, formatMessage({ id: "app.user_already_exist_error" }));
        if (getApplicationFlow() === AppConstatnt.flow.DRIVER) {
            history.push({ pathname: '/signin', state: { mobileNumber: phone.replace('+', '') } })
            return null;
        }
        else {
            history.push('/carrierLogin');
            return null;
        }

    }

    return (
        <form className="form-signin"  >
            <div className="card">

                <div className="card-header uc-blue"></div>
                <div className="card-body p-4">
                    <div className="text-center m-auto">
                        <h4 className="text-dark-50 text-center mt-0 font-weight-bold">{question}</h4>
                    </div>
                </div>
                <div className="d-flex justify-content-center">
                    <CountdownCircleTimer
                        onComplete={() => onTimerComplete()}
                        key={JSON.stringify(selectedCaptcha)}
                        strokeWidth={8}
                        size={75}
                        isPlaying={true}
                        duration={10}
                        colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                        colorsTime={[7, 5, 2, 0]}
                    >
                        {timerText}
                    </CountdownCircleTimer>
                </div>
                <div className="captcharow">
                    {
                        getImagesComponent()
                    }
                </div>
            </div>
            {errorStatus && <ErrornDialog
                error={errorStatus}
                open
            />}
        </form>

    )
}

export default injectIntl(CaptchaVerifications);


